export default __webpack_public_path__ + "static/media/love-you-all.da602dc7.webp";